var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V9.33333H0V0ZM7 2.33333C7.61884 2.33333 8.21233 2.57917 8.64992 3.01675C9.0875 3.45434 9.33333 4.04783 9.33333 4.66667C9.33333 5.2855 9.0875 5.879 8.64992 6.31658C8.21233 6.75417 7.61884 7 7 7C6.38116 7 5.78767 6.75417 5.35008 6.31658C4.9125 5.879 4.66667 5.2855 4.66667 4.66667C4.66667 4.04783 4.9125 3.45434 5.35008 3.01675C5.78767 2.57917 6.38116 2.33333 7 2.33333ZM3.11111 1.55556C3.11111 1.96811 2.94722 2.36378 2.6555 2.6555C2.36378 2.94722 1.96811 3.11111 1.55556 3.11111V6.22222C1.96811 6.22222 2.36378 6.38611 2.6555 6.67783C2.94722 6.96956 3.11111 7.36522 3.11111 7.77778H10.8889C10.8889 7.36522 11.0528 6.96956 11.3445 6.67783C11.6362 6.38611 12.0319 6.22222 12.4444 6.22222V3.11111C12.0319 3.11111 11.6362 2.94722 11.3445 2.6555C11.0528 2.36378 10.8889 1.96811 10.8889 1.55556H3.11111Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutionIcon);
export default __webpack_public_path__ + "static/media/tution-icon.4e7a5238a234a4ea1b38f4c25ffb6644.svg";
export { ForwardRef as ReactComponent };